/**
 * @generated SignedSource<<978de0e6535e37672f95d2a6799018c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTypeAddedEventRationales$data = {
  readonly eventRationales: ReadonlyArray<{
    readonly actor: {
      readonly login: string;
    } | null | undefined;
    readonly issueEvent: {
      readonly id?: string;
    } | null | undefined;
    readonly rationale: string;
  }>;
  readonly " $fragmentType": "IssueTypeAddedEventRationales";
};
export type IssueTypeAddedEventRationales$key = {
  readonly " $data"?: IssueTypeAddedEventRationales$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeAddedEventRationales">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTypeAddedEventRationales",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueEventRationale",
      "kind": "LinkedField",
      "name": "eventRationales",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "actor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rationale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "issueEvent",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "IssueTypeAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "IssueTypeRemovedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "IssueTypeChangedEvent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "0e440cb6fdfad99a383aae2a0485c62a";

export default node;
